import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { AddDispatchEvent } from './adddispatchevent';

import { DispatchEventDetailsBody } from './dispatcheventdetailsview';

import { PCModal } from 'portcall/pcmodal/view';
import { ToggleButton } from 'portcall/togglebutton/view';

export const AddDispatchEventView = SuperCritical(({ modelContainer } : { modelContainer : () => AddDispatchEvent | null }) => {
    const m = modelContainer();
    return (
        <PCModal className="adddispatchevent" shown={() => !!m} onBackDropClick={m?.Cancel}>
            <div className="modal-content pc-card">
                <div className="pc-card-header pc-card-title">Add Event</div>
                {m &&
                    <form className="modal-body">
                        <DispatchEventDetailsBody event={m.Model}
                            canEdit={() => true}
                            validation={m.Validation}
                            localization={m.Localization} />
                        {m.CanManageBills() &&
                            <PublicPrivateView model={m} />
                        }
                        <div className="buttons">
                            <a href="" className="cancel-btn" onClick={noDefault(m.Cancel)}>Cancel</a>
                            <button className="submit-btn pc-button pc-button-primary" onClick={noDefault(m.AddDispatchEvent)}>Submit</button>
                        </div>
                    </form>
                }
            </div>
        </PCModal>
    );
});

let PublicPrivateView = SuperCritical(({ model : m } : { model: AddDispatchEvent }) =>
    <div className="dispatch-evt-details-body">
        <div className="dispatch-evt-vis">
            <span className="dispatch-evt-field-label pc-text-label-color">Visibility</span>
            <div className="dispatch-evt-vis-content">
                <ToggleButton
                    checked={m.BillExportSettings.DraftModel.Billable}
                    onLabel="Private"
                    offLabel="Public"
                    selectedLabelClassName="billable-toggle-selected-label"
                    disabled={!m.CanManageBills()}
                />
            </div>
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./apps/pilots/dispatchdashboard/adddispatcheventview.tsx